export default __webpack_public_path__ + "static/media/portfolio2.4c619558.webp";